export const EVENT_CHANNEL = 'teamworkGraph';
